import {all, call} from 'redux-saga/effects';
import errorSaga from "./errorSaga";
import gameControlSaga from "./gameControl";
import cardSaga from "./cardSaga";
import settingsSaga from "./settingsSaga";
import dealerSaga from "./dealerSaga";

export default function* rootSaga() {
    yield all([
        call(errorSaga),
        call(gameControlSaga),
        call(cardSaga),
        call(settingsSaga),
        call(dealerSaga)
    ])
}